import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Map as MapIcon, MapPin } from "lucide-react"
import FloaterButton from "../../shared/Floaters/FloaterButton.js"

interface KennelMapLinkButtonProps {
  variant: "icon" | "floater" | "labeled"
  species?: "cao" | "gato"
  label?: string
  className?: string
}

export function KennelMapLinkButton({ variant, species, label, className = "" }: KennelMapLinkButtonProps) {
  const navigate = useNavigate()
  const { t } = useTranslation("kennel")
  const LABEL = label ?? t("mapEntry.cta")
  const open = () => navigate(species ? `/mapa?tipo=${species}` : "/mapa")

  if (variant === "floater") {
    return (
      <FloaterButton
        onClick={open}
        ariaLabel={LABEL}
        icon={<MapIcon className="h-[18px] w-[18px]" aria-hidden="true" />}
      />
    )
  }

  if (variant === "labeled") {
    return (
      <button
        type="button"
        onClick={open}
        className={`flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-xl border border-main-purple bg-white px-3 text-sm font-semibold text-main-purple transition-transform active:scale-95 ${className}`}
      >
        <MapPin className="h-4 w-4" aria-hidden="true" />
        {LABEL}
      </button>
    )
  }

  return (
    <button
      type="button"
      onClick={open}
      aria-label={LABEL}
      title={LABEL}
      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-main-purple bg-white text-main-purple transition-transform active:scale-95 ${className}`}
    >
      <MapIcon className="h-5 w-5" aria-hidden="true" />
    </button>
  )
}
